export default __webpack_public_path__ + "static/media/mail_pile.727ab775.png";